import { Link, useLocation } from 'react-router';
import { Button } from '../shared/Button';
import { useAuth } from '../../hooks/useAuth';

export function Header() {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-bg-surface/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" aria-label="LexAssist - Pagina principală">
            <span className="text-2xl font-bold text-accent">LexAssist</span>
          </Link>

          {/* Compact Search - hidden on landing page */}
          {!isLanding && (
            <div className="hidden md:flex flex-1 max-w-xl mx-8">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.currentTarget);
                  const q = formData.get('q') as string;
                  if (q?.trim()) {
                    window.location.href = `/search?q=${encodeURIComponent(q.trim())}`;
                  }
                }}
                className="w-full flex gap-2"
                role="search"
              >
                <label htmlFor="header-search" className="sr-only">
                  Caută în legislație
                </label>
                <input
                  id="header-search"
                  type="search"
                  name="q"
                  placeholder="Caută în legislație..."
                  className="flex-1 px-4 py-2 bg-bg-elevated text-text-primary border border-border rounded-md text-sm placeholder:text-text-tertiary focus:outline-none focus:ring-2 focus:ring-accent focus:border-border-focus"
                />
                <Button type="submit" size="sm" aria-label="Caută">
                  Caută
                </Button>
              </form>
            </div>
          )}

          {/* Auth buttons / User menu */}
          <nav aria-label="Navigare principală">
            <div className="flex items-center gap-3">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/profile"
                    className="text-sm text-text-secondary hover:text-text-primary transition-colors"
                    aria-label={`Profil: ${user?.email}`}
                  >
                    {user?.email}
                  </Link>
                  <Button variant="ghost" size="sm" onClick={logout} aria-label="Deconectare">
                    Deconectare
                  </Button>
                </>
              ) : (
                <>
                  <Link to="/login">
                    <Button variant="ghost" size="sm" aria-label="Autentificare">
                      Autentificare
                    </Button>
                  </Link>
                  <Link to="/register">
                    <Button variant="primary" size="sm" aria-label="Înregistrare">
                      Înregistrare
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
